/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LocationContext } from "./LocationContext";
import {
  LocationContextFromJSON,
  LocationContextFromJSONTyped,
  LocationContextToJSON,
  LocationContextToJSONTyped,
} from "./LocationContext";
import type { Contact } from "./Contact";
import {
  ContactFromJSON,
  ContactFromJSONTyped,
  ContactToJSON,
  ContactToJSONTyped,
} from "./Contact";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface UpdateLocationBody
 */
export interface UpdateLocationBody {
  /**
   *
   * @type {LocationContext}
   * @memberof UpdateLocationBody
   */
  context: LocationContext;
  /**
   *
   * @type {Location}
   * @memberof UpdateLocationBody
   */
  location: Location;
  /**
   *
   * @type {Contact}
   * @memberof UpdateLocationBody
   */
  contact: Contact;
  /**
   *
   * @type {string}
   * @memberof UpdateLocationBody
   */
  reference: string;
  /**
   *
   * @type {string}
   * @memberof UpdateLocationBody
   */
  booth: string;
  /**
   *
   * @type {string}
   * @memberof UpdateLocationBody
   */
  deadline?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateLocationBody
   */
  amazonReferenceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateLocationBody
   */
  amazonShipmentId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateLocationBody
   */
  notifyCarrier?: boolean | null;
}

/**
 * Check if a given object implements the UpdateLocationBody interface.
 */
export function instanceOfUpdateLocationBody(
  value: object,
): value is UpdateLocationBody {
  if (!("context" in value) || value["context"] === undefined) return false;
  if (!("location" in value) || value["location"] === undefined) return false;
  if (!("contact" in value) || value["contact"] === undefined) return false;
  if (!("reference" in value) || value["reference"] === undefined) return false;
  if (!("booth" in value) || value["booth"] === undefined) return false;
  return true;
}

export function UpdateLocationBodyFromJSON(json: any): UpdateLocationBody {
  return UpdateLocationBodyFromJSONTyped(json, false);
}

export function UpdateLocationBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateLocationBody {
  if (json == null) {
    return json;
  }
  return {
    context: LocationContextFromJSON(json["context"]),
    location: LocationFromJSON(json["location"]),
    contact: ContactFromJSON(json["contact"]),
    reference: json["reference"],
    booth: json["booth"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
    amazonReferenceId:
      json["amazonReferenceId"] == null ? undefined : json["amazonReferenceId"],
    amazonShipmentId:
      json["amazonShipmentId"] == null ? undefined : json["amazonShipmentId"],
    notifyCarrier:
      json["notifyCarrier"] == null ? undefined : json["notifyCarrier"],
  };
}

export function UpdateLocationBodyToJSON(json: any): UpdateLocationBody {
  return UpdateLocationBodyToJSONTyped(json, false);
}

export function UpdateLocationBodyToJSONTyped(
  value?: UpdateLocationBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    context: LocationContextToJSON(value["context"]),
    location: LocationToJSON(value["location"]),
    contact: ContactToJSON(value["contact"]),
    reference: value["reference"],
    booth: value["booth"],
    deadline: value["deadline"],
    amazonReferenceId: value["amazonReferenceId"],
    amazonShipmentId: value["amazonShipmentId"],
    notifyCarrier: value["notifyCarrier"],
  };
}
